import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Громкость 0…1, как её принимает фасад звонка.
export const DEFAULT_PARTICIPANT_VOLUME = 1

interface ParticipantVolumeState {
  volumes: Record<string, number>
  setVolume: (participantId: string, volume: number) => void
}

// Персональная громкость каждого участника переживает перезаход в звонок:
// «этот человек всегда тихий» — свойство собеседника, а не сессии. Пресет, не
// секрет — localStorage. Громкость сознательно живёт вне callStore: там
// единственный писатель — адаптер, и снапшоты участников пересоздаются на
// каждом событии SDK, затирая настройку слушателя.
export const useParticipantVolumes = create<ParticipantVolumeState>()(
  persist(
    (set) => ({
      volumes: {},
      setVolume: (participantId, volume) =>
        set((s) => {
          const clamped = Math.round(Math.min(1, Math.max(0, volume)) * 100) / 100
          // Дефолт не храним: иначе словарь растёт на каждого встреченного
          // участника и никогда не чистится.
          if (clamped === DEFAULT_PARTICIPANT_VOLUME) {
            if (!(participantId in s.volumes)) return s
            const { [participantId]: _dropped, ...rest } = s.volumes
            return { volumes: rest }
          }
          return { volumes: { ...s.volumes, [participantId]: clamped } }
        }),
    }),
    {
      name: 'telemost.participant-volume',
      partialize: (s) => ({ volumes: s.volumes }),
    },
  ),
)

export function participantVolume(volumes: Record<string, number>, participantId: string): number {
  return volumes[participantId] ?? DEFAULT_PARTICIPANT_VOLUME
}
